import { render } from "./JudgmentType.vue?vue&type=template&id=42089b3d"
import script from "./JudgmentType.vue?vue&type=script&lang=ts"
export * from "./JudgmentType.vue?vue&type=script&lang=ts"
script.render = render

export default script